module.exports = __webpack_public_path__ + "static/img/3.2131074.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/eng/3.png
// module id = W5iG
// module chunks = 0